import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { GrInstagram } from "react-icons/gr";
import { NavLink } from 'react-router-dom';

const InstagramPosts = ({ count = 4 }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        setLoading(true);
        const accessToken = 'IGAAHI2PJBKYJBZAGFSaGlxQ2JYd1N5eXlMZAGV2cDVYSGdYMkpfZAnJNNzhFelpUMTVzQUR4WXRiNXhrREN4MjdoNWRmbGVIVzhiblFiOUZAXMFVtNFJ2RzAxamoxQWdCbVEwZATgtdUdZAd3RMeW1hN1d1azNB';
        const fields = 'id,media_type,media_url,permalink,thumbnail_url,timestamp,caption';
        
        const response = await fetch(
          `https://graph.instagram.com/me/media?fields=${fields}&access_token=${accessToken}&limit=${count}`
        );
        
        if (!response.ok) {
          throw new Error('Failed to fetch Instagram posts');
        }
        
        const data = await response.json();

        const processedPosts = await Promise.all(data.data.map(async post => {
          if (post.media_type === 'CAROUSEL_ALBUM') {
            try {
              const childrenResponse = await fetch(
                `https://graph.instagram.com/${post.id}/children?fields=id,media_type,media_url,thumbnail_url&access_token=${accessToken}`
              );
              
              if (childrenResponse.ok) {
                const childrenData = await childrenResponse.json();
                if (childrenData.data && childrenData.data.length > 0) {
                  const firstChild = childrenData.data[0];
                  return {
                    ...post,
                    carousel_media_url: firstChild.media_url,
                    carousel_media_type: firstChild.media_type,
                    carousel_thumbnail_url: firstChild.thumbnail_url
                  };
                }
              }
            } catch (err) {
              console.error('Error fetching carousel children:', err);
            }
          }
          return post;
        }));

        setPosts(processedPosts || []);
      } catch (err) {
        console.error('Error fetching Instagram posts:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchInstagramPosts();
  }, [count]);

  if (loading) {
    return (
      <div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
      </div>
    );
  }

  return (
    <div className="instagram-posts-container">
        <h3><NavLink to="https://www.instagram.com/nukeproofbikes_czsk/"><GrInstagram /> nukeproofbikes_czsk</NavLink></h3>
        {posts.map((post) => (
          <motion.a 
            key={post.id}
            href={post.permalink}
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-post"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <div className="instagram-posts">
            <img 
              src={
                post.media_type === 'VIDEO' ? post.thumbnail_url :
                post.media_type === 'CAROUSEL_ALBUM' ? 
                  (post.carousel_media_type === 'VIDEO' ? post.carousel_thumbnail_url : post.carousel_media_url) :
                  post.media_url
              } 
              alt={post.caption?.substring(0, 50) || 'Instagram příspěvek'}
            />
            <p><label>{post.caption}</label></p>
            </div>
          </motion.a>
        ))}
    </div>
  );
};

export default InstagramPosts;